export default __webpack_public_path__ + "static/media/logo.221899f9.png";